import type { BookableBookingObjectDto } from "../typings/resource-calendar.types";
import type { BookingResourceInfo } from "../typings/booking-resource-info.types";
import { createStubResourceInfoForResourceBooking } from "./createStubResourceInfoForResourceBooking";

export function resourceInfoFromPrefetchOrStub(
  prefetched: BookingResourceInfo | null | undefined,
  row: BookableBookingObjectDto
): BookingResourceInfo {
  return prefetched ?? createStubResourceInfoForResourceBooking(row);
}
